import {activateTotp, enrollFactor, pollActivatePush} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import React from "react";
import {AuthBack, AuthBox, AuthButton, AuthContent, AuthIcon, AuthQr} from "../../common/AuthBox";
import IconUser from "../../../../images/icon_user.png";
import IconOkta from "../../../../images/icon_Okta.png";
import {useHistory} from "react-router-dom";
import {CBTextBox} from "../../common/ContentBox";
import {useFactors} from "../../../contexts/FactorsContext";

const playStoreOktaVerifyLink = process.env.REACT_APP_OKTA_VERIFY_PLAY_STORE;
const appStoreOktaVerifyLink = process.env.REACT_APP_OKTA_VERIFY_APP_STORE;

const OktaEnrollOktaPush = () => {
    const [enrollStep, setEnrollStep] = useState(1);
    const [qrCodeLink, setQrCodeLink] = useState(null);
    const [factorId, setFactorId] = useState(null);
    const [passCode, setPassCode] = useState(null);
    const [totpFactorId, setTotpFactorId] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [barCodePage, setBarCodePage] = useState(true);
    const [sharedSecret, setsharedSecret] = useState(null);
    const [resend, setResend] = useState(false);
    const [currentIntervalId, setCurrentIntervalId] = useState(null);
    const history = useHistory();
    const {refresh} = useFactors();

    useEffect(() => {
        if (barCodePage && factorId){
            const startPoll = async () => {
                let intervalId = setInterval(async () => {
                    const pollActivatePushApi = await runApi(
                        'oktaPoll',
                        () => pollActivatePush(factorId)
                    );

                    if (!pollActivatePushApi?.data?.status) {
                        clearInterval(intervalId);
                        toast.error("Cannot connect to server");
                    }

                    let dataJson = pollActivatePushApi?.data?.data;
                    let factorResult = dataJson?.factorResult;
                    let status = dataJson?.status;

                    if (factorResult === "TIMEOUT") {
                        clearInterval(intervalId);
                        setResend(true);
                        toast.error("Activation timeout");
                    } else if (status === "ACTIVE") {
                        clearInterval(intervalId);
                        toast.success("Activate successfully");
                        finishActivate();
                    }
                }, 5000);
                setCurrentIntervalId(intervalId);
            }


            const finishActivate = () => {
                refresh();
                history.push('/profile/mfa');
            }

            if (factorId != null) {
                startPoll();
            }
        }
    }, [factorId, history, refresh, barCodePage]);

    const toTotp = async () => {
        enrollTotp();
        setBarCodePage(false);
    }

    const enrollTotp = async () => {
        stopPolling();
        const enrollOktaTotpResponse = await runApi(
            'enrollOktaTotp',
            () => enrollFactor("token:software:totp", "OKTA")
        );

        if (!enrollOktaTotpResponse?.data?.status) {
            return;
        }

        setTotpFactorId(enrollOktaTotpResponse?.data?.data?.id);
        setsharedSecret(enrollOktaTotpResponse?.data?.data?._embedded?.activation?.sharedSecret);
    }

    const enroll = async () => {
        setResend(false);
        setQrCodeLink(null);
        setEnrollStep(3);
        stopPolling();
        const enrollOktaPushResponse = await runApi(
            'enrollOktaPush',
            () => enrollFactor("push", "OKTA")
        );

        if (!enrollOktaPushResponse?.data?.status) {
            return;
        }

        setQrCodeLink(enrollOktaPushResponse?.data?.data?._embedded?.activation?._links?.qrcode?.href);
        setsharedSecret(enrollOktaPushResponse?.data?.data?._embedded?.activation?.sharedSecret);
        setFactorId(enrollOktaPushResponse?.data?.data?.id);
    }

    const finishActivate = () => {
        refresh();
        history.push('/profile/mfa');
    }

    const activate = async () => {
        const activateGoogleAuthResponse = await runApi(
            'activate',
            () => activateTotp(totpFactorId, passCode)
        );

        if (!activateGoogleAuthResponse?.data?.status) {
            return;
        }

        toast.success("Activate Okta veryify successfully.")
        finishActivate();
    }

    const toActivate = () => {
        setEnrollStep(4);
    }

    const toStep2 = () => {
        setEnrollStep(2);
    }

    const backToBarCodePage = () => {
        setBarCodePage(true);
        setQrCodeLink(null);
        enroll();
    }

    const stopPolling = () => {
        setFactorId(null);
        clearInterval(currentIntervalId);
    }

    return (
        <AuthBox>
            <AuthIcon src={enrollStep === 1 ? IconUser : IconOkta}/>
            {enrollStep === 1 && <AuthContent><p><strong>Set up multifactor authentication</strong></p>
                <p>Your company requires multifactor authentication to add an additional layer of security when
                    signing in to your Okta account.</p>
                <div className="google-authenticator clearfix">
                    <img src={IconOkta} className="icon_GA" alt={'webAuthn'}/>
                    <div className="right">
                        <p><strong>Okta Verify</strong></p>
                        <p>Use a push notification sent to the mobile app.</p>
                        <button className="btn_setup" onClick={() => toStep2()}>Setup</button>
                    </div>
                </div>
            </AuthContent>}
            {enrollStep === 2 &&
            <AuthContent>
                <p><strong>Setup Okta Verify</strong></p>
                <form className="select-device">
                    <label>Select your device type</label>
                    <div><input type="radio" name="device-type"
                                onClick={() => setSelectedDevice("iPhone")}/> iPhone
                    </div>
                    <div><input type="radio" name="device-type"
                                onClick={() => setSelectedDevice("Android")}/> Android
                    </div>
                </form>
                {selectedDevice &&
                <div className="google-authenticator clearfix" style={{"border-top": "1px solid #eee"}}>
                    <img src={IconOkta} className="icon_GA" alt="iconOkta"/>
                    <div className="right">
                        {selectedDevice === "iPhone" &&
                        <p>Download <a href={appStoreOktaVerifyLink} rel="noreferrer" target="_blank" className="blue">Okta Verify from the App
                            Store</a> onto
                            your
                            mobile device.</p>}
                        {selectedDevice === "Android" &&
                        <p>Download <a href={playStoreOktaVerifyLink} rel="noreferrer" target="_blank" className="blue">Okta Verify from the Google Play
                            Store</a> onto
                            your
                            mobile device.</p>}
                    </div>
                </div>
                }
                {selectedDevice && <AuthButton buttonEvent={() => enroll()} buttonText={"Next"}/>}
                <AuthBack src="/profile/mfa/enroll/OKTA/push"/>
            </AuthContent>}
            {enrollStep === 3 && <AuthContent>
                <p><strong>Setup Okta Verify</strong></p>
                <AuthQr style={{display: (barCodePage ? 'block' : 'none')}}
                        displayText={'Launch Okta Verify application on your mobile device and select Add an account.'}
                        src={qrCodeLink} noBarCodeEvent={() => toTotp()}
                resend={resend} refreshCodeEvent={()=>enroll()}/>
                <div style={{display: (barCodePage ? 'none' : 'block')}}>
                    <p>Can't scan barcode?</p>
                    <p>Setup manually without push notification</p>
                    <p>To set up manually enter your Account username and then input the following in the Secret Key
                        Field
                    </p>
                    <form className="enter-code">
                        <CBTextBox disabled value={sharedSecret}></CBTextBox>
                    </form>
                    <AuthButton buttonEvent={() => toActivate()} buttonText={"Verify"}/></div>
                <AuthBack src="/profile/mfa/enroll/OKTA/push"/>
                <span style={{float: 'right', display: (barCodePage ? 'none' : 'block'), cursor: 'pointer'}} className="link-back"
                      onClick={() => backToBarCodePage()}>Scan barcode</span>
            </AuthContent>}
            {enrollStep === 4 && <AuthContent>
                <p><strong>Set up multifactor authentication</strong></p>
                <p>Enter Code displayed from the application</p>
                <form className="enter-code">
                    <label>Enter Code</label>
                    <CBTextBox disabled={false} value={passCode}
                               onChange={e => setPassCode(e.target.value)}></CBTextBox>
                </form>

                <AuthButton buttonEvent={() => activate()} buttonText={"Verify"}/>
                <AuthBack src="/profile/mfa/enroll/OKTA/push"/>
            </AuthContent>}</AuthBox>
    );
}

export default OktaEnrollOktaPush;
